<template>
  <div
    :style="{
      backgroundColor: section.styles.backgroundColor || '#ffffff',
      padding: section.styles.padding || '60px 20px',
    }"
  >
    <div class="max-w-3xl mx-auto">
      <h2 v-if="section.content.title" class="text-3xl font-bold text-gray-900 mb-8 text-center">{{ section.content.title }}</h2>
      <div class="space-y-3">
        <details
          v-for="(item, index) in section.content.items || []"
          :key="index"
          class="group rounded-lg border border-gray-200 bg-white p-4"
        >
          <summary class="cursor-pointer font-semibold text-gray-900 list-none flex items-center justify-between">
            <span>{{ item.question }}</span>
            <span class="text-green-600 text-sm">+</span>
          </summary>
          <p class="mt-3 text-sm text-gray-600 leading-relaxed">{{ item.answer }}</p>
        </details>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: { type: Object, required: true },
    preview: { type: Boolean, default: false },
  },
}
</script>
